<template>
  <transition name="fade" mode="out-in">
    <div class="base-drawer" ref="backdrop" v-if="$props.visible" @click="handleBackdropClick">
      <div class="drawer-content" :class="contentClasses">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'base-drawer',
  data () {
    return {
      contentVisible: false
    }
  },
  props: {
    visible: Boolean,
    position: {
      type: String,
      default: 'left',
      validator: (position) => {
        const availablePositions = ['left', 'right']
        return availablePositions.includes(position)
      }
    },
    preventBackdropClose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    contentClasses () {
      return {
        [`position-${this.$props.position}`]: this.$props.position,
        'content-visible': this.contentVisible
      }
    }
  },
  watch: {
    visible: {
      handler (newVal) {
        setTimeout(() => {
          this.contentVisible = newVal
        }, 50)
      },
      immediate: true
    }
  },
  methods: {
    handleBackdropClick (e) {
      if (e.target === this.$refs.backdrop && !this.$props.preventBackdropClose) {
        this.contentVisible = false
        setTimeout(() => {
          this.$emit('close-drawer')
        }, 300)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.base-drawer {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(51, 51, 51, 0.9);
  backdrop-filter: blur(2px);
  z-index: map_get($z-index, modal);

  .drawer-content {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    background-color: $grey;
    transition: transform 0.3s ease-in-out;

    @media (map_get($breakpoints, md)) {
      max-width: 968px;
    }

    &.position-left {
      left: 0;
      right: auto;
      transform: translateX(-100%);
    }

    &.position-right {
      right: 0;
      left: auto;
      transform: translateX(100%);
    }

    &.content-visible {
      transform: translateX(0);
    }
  }
}
</style>
